import { assign, findIndex, remove, isEmpty } from 'lodash';
import  * as types from '../actions/ActionTypes';
// import {IControlError, IControlSchema} from "../components/Controls";
// import * as equal from "fast-deep-equal";
import {Dictionary} from "../types/Dictionary";
import {PAGINATION} from '../const/forms';

export type ActualizeStatuses = 'working' | 'suspended'

export interface FormState {
    form: any,
    forms: Array<any>,
    pagination: any,
    history: Array<any>,
    mode: ActualizeStatuses,
    modeLoaded: boolean,
    loaders: any,
    values: Array<any>,
    section:string,
    listUserForms: Array<any>,
    checkedPanel: Array<string>,
    user: any,
    companies: Array<any>,
    countToSend: number,
    errors: Dictionary<any | undefined>,
    createRequestError: {
        message?: string,
        isDisplayed: boolean,
    },
    visited: Dictionary<boolean>,
    allVisited: boolean,
    readonly?: boolean,
    status?: number,
    formUid?: string,
    process_id?: number,
    form_type?: string,
    tags: Array<any>,
    cities: Array<any>,
    typeForm?: string,
    changed_controls?: Array<string>,
    senderData?: any,
    votesResult?: any,
    settings?: Record<string, unknown>
}

const defaultState : FormState = {
    form: {},
    pagination: PAGINATION,
    forms: [],
    mode: 'working',
    modeLoaded: true,
    loaders: {},
    values:[],
    section:'1',
    listUserForms:[],
    checkedPanel:[],
    user: {},
    companies: [],
    countToSend: 0,
    errors: {},
    visited: {},
    allVisited: false,
    tags: [],
    cities: [],
    history: [],
    senderData: {},
    votesResult: [],
    createRequestError: {
        isDisplayed: false
    }
};

export interface Action{
    type:string;
    payload: any;
}

function updateControls(controls: any[], updater: (control: any) => void) {
    return controls.map(c => {
        if(c.controls) {
            c = {...c, controls: updateControls(c.controls, updater)};
        }

        return updater(c);
    })
}

function updateStateControls(state: any, updater: (control: any) => void) {
    const newForm = {
        ...state.form,
        sections: state.form.sections.map(s => ({
            ...s,
            controls: updateControls(s.controls, updater)
        }))
    };
    return {...state, form: newForm};
}

export function forms(state: FormState = defaultState, action: Action): FormState{
    switch(action.type){
        case types.LOADING_START:
            state.loaders[action.payload] = true;
            return assign({}, state, { loaders: { ...state.loaders }});
        case types.LOADING_FINISH:
            delete state.loaders[action.payload];
            return assign({}, state, { loaders: { ...state.loaders }});
        case types.FETCH_FORM:
            return assign({},state,{ form: action.payload, errors: {}, visited: {}, allVisited: false });
        case types.FETCH_FORMS:
            return assign({}, state, {
                forms: typeof action.payload.items !== 'undefined' ? [ ...action.payload.items] : [ ...action.payload ],
                pagination: {
                    page: action.payload.page,
                    total: action.payload.total_items_count,
                    pagesize: PAGINATION.pagesize
                }
            });
        case types.FETCH_COMPANIES:
            return assign({}, state, { companies: action.payload || [] });
        case types.FETCH_SETTINGS: {
            if (typeof action.payload.suspended !== 'undefined') {
                const formMode = action.payload.suspended ? 'suspended' : 'working'

                return assign({}, state, { mode: formMode } );
            }
            return state
        }
        case types.FETCH_SETTINGS_FINISHED: {
            return assign({}, state, { modeLoaded: true } );
        }

        case types.ADD_VALUE: {
            const stamp = +new Date();
            const valuesLookUp: { [key: string]: any }  = {};
            action.payload.forEach(p => valuesLookUp[p.controlid] = p.value);
            const newForm = {
                ...state.form,
                sections: state.form.sections.map(s => ({
                    ...s,
                    $$timestamp: stamp,
                    controls: updateControls(s.controls, c => ({...c, value: valuesLookUp[c.id]}))
                }))
            };
            return assign({}, state, {values: [...action.payload], form: newForm});
        }
        case types.SET_SECTION:
            return assign({},state,{ section:action.payload.id });
        case types.SET_FORM_UID:
            return assign({}, state, { formUid: action.payload } );
        case types.CLEAR_VALUES:
            return  assign({},state,{ values:[], form:{}, readonly: undefined, errors: {}, visited: {}, allVisited: false  });
        case types.FETCH_VALUES:
            return assign({},state, { listUserForms: action.payload});
        case types.OPEN_FORM: {
            const valuesLookUp: { [key: string]: any }  = {};
            action.payload.values.forEach(p => valuesLookUp[p.controlid] = p.value);
            action.payload.form = {
                ...action.payload.form,
                sections: action.payload.form.sections.map(s => ({
                    ...s,
                    controls: updateControls(s.controls, c => ({...c, value: valuesLookUp[c.id] || c.value}))
                }))
            };

            return assign({}, state, {...action.payload, errors: {}, visited: {}, allVisited: false, senderData: { ...action.payload.sender_data }});
        }
        case types.CHECKED_PANEL:
            return action.payload.checked ?
                assign({},state, { checkedPanel: [...state.checkedPanel, action.payload.panelId] }) :
                assign({},state, { checkedPanel: remove(state.checkedPanel, (id) => id !== action.payload.panelId ) });
        case types.AUTH_USER_SUCCESS:

            // TODO: If will be a users roles - remove template from payload
            return assign({},state, { user: { userRole: 'user', ...action.payload }});
        case types.ATTEMPT_TO_SEND:
            return assign({},state,{ countToSend: action.payload });
        case types.SET_STATUS_DEFAULT:
            return assign({},state,{ status: action.payload });
        case types.CREATE_REQUEST_BEFORE:
            return assign({}, state,{ checkedPanel: [] });
        case types.REQUEST_UNCHEK_UPDATE:
            let requests = [...state.listUserForms];
            let idx = findIndex(requests, (obj) => obj.formId === action.payload.formId &&
                                                    obj.valuesId === action.payload.valuesId);
            if(idx > -1){
                requests[idx].updateState = '';
            }
            return  assign({},state, { listUserForms: requests});
        case types.MARK_VISITED: {
            if (!state[action.payload]) {
                return {...state, visited: {...state.visited, ...{[action.payload]: true}}};
            }
            return state;
        }
        case types.SET_ERROR: {
            if(state.errors[action.payload.id] !== action.payload.error) {
                return {...state, errors: {...state.errors, ...{[action.payload.id]: action.payload.error}}};
            }
            return state;
        }
        case types.SET_CREATE_REQUEST_ERROR: {
            return {
                ...state, createRequestError: { 
                ...state.createRequestError, message: action.payload.error
                }
            }
        }
        case types.SET_IS_CREATE_REQUEST_ERROR_DISPLAYED: {
            return {
                ...state, createRequestError: { 
                ...state.createRequestError, isDisplayed: action.payload.isDisplayed
                }
            }
        }
        case types.MARK_ALL_VISITED: {
            return {...state, errors: {}, allVisited: true};
        }
        case types.SET_TAGS: {
            return {...state, tags: [...action.payload]};
        }
        case types.SET_CITIES: {
            return {...state, cities: [...action.payload]};
        }

        case types.SET_HISTORY: {
            return {...state, history: [...action.payload]};
        }

        case types.FETCH_VOTES_RESULT: {
            return {...state, votesResult: action.payload}
        }

        case 'SAVE_TEXT_ANSWER': {
            return {...state, votesResult: [
                ...state.votesResult.map((item) => {
                    if(item.id === action.payload.id) {
                        return {
                            ...item,
                            answer: action.payload.text
                        }
                    }
                    return item;
                })
            ]}
        }

        case 'UPLOAD_FILE_ANSWER': {
            return {...state, votesResult: [
                ...state.votesResult.map((item) => {
                    if(item.id === action.payload.id) {
                        return {
                            ...item,
                            files: [
                                ...item.files,
                                action.payload.file
                            ]
                        }
                    }
                    return item;
                })
            ]}
        }

        case 'DELETE_FILE_ANSWER': {
            return {...state, votesResult: [
                ...state.votesResult.map((item) => {
                    if(item.id === action.payload.id) {
                        return {
                            ...item,
                            files: [
                                ...item.files.filter((item) => {
                                    return item.id !== action.payload.file_uuid
                                })
                            ]
                        }
                    }
                    return item;
                })
            ]}
        }

        case 'SEND_ANSWER': {
            return {...state, votesResult: [
                ...state.votesResult.map((item) => {
                    if(item.id === action.payload.id) {
                        return {
                            ...item,
                            is_sent: true
                        }
                    }
                    return item;
                })
            ]}
        }

        default:
            return state;
    }
}
